export default {"src":"/gb/en/_next/static/media/search-bar.d40fed2d.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};